import ScrollLayout from '@/layouts/ScrollLayout.vue';

export default function install(_Vue) {
  _Vue.component(ScrollLayout.name || 'ScrollLayout', ScrollLayout);
}
